// extracted by mini-css-extract-plugin
export default {"root":"root___vzP6_","inner":"inner___Z_stQ","sticky":"sticky___wVd9l","footer":"footer___R75oA","searchButton":"searchButton___CFRhf"};